export function kkNextgenGalleries() {
    const galleryOverviews = document.getElementsByClassName('ngg-galleryoverview');
    if (galleryOverviews.length > 0) {
      Array.from(galleryOverviews).forEach(galleryOverview => {
        const sectionTag = document.createElement('section');
        sectionTag.classList.add('block', 'block-gallery', 'pt-default', 'pb-default', 'px-default', 'bg-white');

        // Wrap the existing gallery markup without recreating it.
        const parent = galleryOverview.parentNode;
        if (!parent) return;
        parent.insertBefore(sectionTag, galleryOverview);
        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('wrapper-max');
        sectionTag.appendChild(wrapperDiv);
        wrapperDiv.appendChild(galleryOverview);
      });
    }
}
